/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AgencyGroupConfiguration,
    AgencyGroupConfigurationFromJSON,
    AgencyGroupConfigurationToJSON,
    AgencyGroupListItem,
    AgencyGroupListItemFromJSON,
    AgencyGroupListItemToJSON,
    AgencyGroupListQuery,
    AgencyGroupListQueryFromJSON,
    AgencyGroupListQueryToJSON,
} from '../models';

export interface ApiAgencyGroupListDataPostRequest {
    agencyGroupListQuery?: AgencyGroupListQuery;
}

/**
 * no description
 */
export class AgencyGroupListApi extends runtime.BaseAPI {

    /**
     */
    async apiAgencyGroupListConfigurationGetRaw(): Promise<runtime.ApiResponse<AgencyGroupConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyGroupConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyGroupListConfigurationGet(): Promise<AgencyGroupConfiguration> {
        const response = await this.apiAgencyGroupListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiAgencyGroupListDataPostRaw(requestParameters: ApiAgencyGroupListDataPostRequest): Promise<runtime.ApiResponse<Array<AgencyGroupListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyGroupList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyGroupListQueryToJSON(requestParameters.agencyGroupListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AgencyGroupListItemFromJSON));
    }

    /**
     */
    async apiAgencyGroupListDataPost(requestParameters: ApiAgencyGroupListDataPostRequest): Promise<Array<AgencyGroupListItem>> {
        const response = await this.apiAgencyGroupListDataPostRaw(requestParameters);
        return await response.value();
    }

}
